import { IconAlertCircle } from "@tabler/icons-react";

import { errorMessage } from "../../api/queries";

/** Neutral placeholder shown while a query is in flight. */
export function LoadingBlock({ label }: { label: string }): JSX.Element {
  return (
    <p className="state-block" role="status">
      {label}
    </p>
  );
}

interface ErrorBlockProps {
  error: unknown;
  onRetry?: () => void;
}

/** Error placeholder quoting the server, with an optional retry action. */
export function ErrorBlock({ error, onRetry }: ErrorBlockProps): JSX.Element {
  return (
    <div className="state-block state-block--error" role="alert">
      <span className="state-block__title">
        <IconAlertCircle size={14} style={{ verticalAlign: "-2px" }} aria-hidden="true" />{" "}
        {errorMessage(error)}
      </span>
      {onRetry ? (
        <button type="button" className="btn btn--sm" onClick={onRetry}>
          Try again
        </button>
      ) : null}
    </div>
  );
}

/** Empty-state placeholder. */
export function EmptyBlock({ label }: { label: string }): JSX.Element {
  return <p className="state-block">{label}</p>;
}
